import { Modal } from "Components/Modals/Modal";
import AtentionIcon from "Assets/Images/atention.svg";
import { Box } from "styles/globalComponents";
import { Button } from "Components/Button";

interface ModalProductsErrorIAProps {
  opened: boolean;
  setOpened: (status: boolean) => void;
  failedProducts: { product: string; error: string }[];
}

export const ModalProductsErrorIA = ({
  failedProducts,
  opened,
  setOpened,
}: ModalProductsErrorIAProps) => {
  return (
    <Modal
      isOpen={opened}
      requestClose={() => setOpened(false)}
      closeOverlay
      maxHeight="650"
      modalIcon={AtentionIcon}
      renderHeading={() => (
        <h2 className="text-center">
          Os produtos abaixo não foram adicionados ao carrinho.
        </h2>
      )}
      renderActions={() => (
        <Box>
          <Box>
            {failedProducts.map((product) => (
              <Box
                display="flex"
                direction="column"
                justify="flex-start"
                align="start"
                gap="5"
                mb="20"
              >
                <strong className="products-error bold">
                  {product.product}
                </strong>
                <span className="products-error">{product.error}</span>
              </Box>
            ))}
          </Box>

          <Box display="flex" justify="center" mt="30">
            <Button onClick={() => setOpened(false)}>OK</Button>
          </Box>
        </Box>
      )}
    />
  );
};
